<template>
  <div>
    <div class="titleclass">
      <h3>{{ typeName }}</h3>
    </div>
    <div class="search-bar">
      <el-input
        v-model="searchQuery"
        placeholder="请输入明确的主体名称或者统一社会信用代码"
        clearable
        style="width: 600px"
      >
        <el-button
          style="background-color: #005392;color: #fff;"
          slot="append"
          icon="el-icon-search"
          @click="handleSearch"
        >查询</el-button>
      </el-input>
    </div>
    <div class="content-container">
      <el-table
        :data="filteredData"
        border
        :header-cell-style="{ 'background-color': '#005392','color':'#fff' }"
      >
        <el-table-column
          align="center"
          v-for="col in columns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import { adminList } from "@/api/Integratedbar";
export default {
  props: ["type"],
  data() {
    return {
      searchQuery: "",
      tableData: []
    };
  },
  computed: {
    typeName() {
      const names = {
        1: "行政许可",
        2: "行政处罚",
        3: "诚实守信",
        4: "重大税收违法案件当事人",
        5: "严重失信主体名单"
        // 6: "失信被执行人"
      };
      return names[this.type] || "未知类型";
    },
    // 动态列配置
    columns() {
      const baseColumns = [{ prop: "", label: "", width: 0 }];
      if (this.type == 1 || this.type == 2) {
        return [
          ...baseColumns,
          { label: "统一社会信用代码", prop: "code" },
          { label: "记录次数", prop: "count" }
        ];
      } else if (this.type == 3 || this.type == 5) {
        return [
          ...baseColumns,
          { label: "主题名称", prop: "title" },
          { label: "统一社会信用代码", prop: "code" },
          { label: "记录次数", prop: "count" }
        ];
      } else if (this.type == 4) {
        return [
          ...baseColumns,
          { label: "纳税人名称", prop: "title" },
          { label: "统一社会信用代码", prop: "code" },
          { label: "案件性质", prop: "count" }
        ];
      }

      return baseColumns;
    },
    // 过滤后的数据
    filteredData() {
      if (!this.searchQuery) return this.tableData;
      const query = this.searchQuery.toLowerCase();
      console.log(this.filteredData);
      return this.tableData.filter(
        item =>
          item.name.toLowerCase().includes(query) ||
          (item.code && item.code.toLowerCase().includes(query))
      );
    }
  },
  watch: {
    type: {
      immediate: true,
      handler() {
        this.loadData();
      }
    }
  },
  mounted() {
    this.getadminList();
  },
  methods: {
    handleSearch() {},

    async getadminList() {
      console.log("行政许可");
      const res = await adminList();
      console.log(res, "行政许可");
    },
    // 加载数据
    async loadData() {
      try {
        // 模拟API请求（实际项目替换为axios调用）
        const mockData = {
          1: [
            { name: "企业A", code: "913205******1234", count: 5 },
            { name: "企业B", code: "913205******5678", count: 2 }
          ]
        };
        // console.log(mockData, "mockData[this.type]");

        this.tableData = mockData[this.type] || [];
        // console.log(this.tableData, "mockData");
      } finally {
        console.log();
      }
    }
  }
};
</script>

<style scoped lang="less">
.titleclass {
  width: 100%;
  display: flex;
  justify-content: center;
  h3 {
    color: #005392;
    font-size: 24px;
    border-bottom: 4px solid #005392;
  }
}
.search-bar {
  display: flex;
  justify-content: center;
  margin: 45px 0;
}
.content-container {
}
</style>